import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/FirebaseProvider';

export interface GlobalSettings {
  newsItemPageSize?: number;
  maximumAutomaticDailySummaries?: number;
  saveNewsItemContent?: boolean;
  // Add other global settings as needed
}

/**
 * Retrieves global settings from Firestore
 * @returns Promise with global settings object
 */
export const getGlobalSettings = async (): Promise<GlobalSettings> => {
  try {
    const settingsRef = doc(db, 'settings', 'global');
    const settingsDoc = await getDoc(settingsRef);
    
    if (settingsDoc.exists()) {
      const settings = settingsDoc.data() as GlobalSettings;
      return settings;
    } else {
      return {};
    }
  } catch (error) {
    console.error('Error retrieving global settings:', error);
    return {};
  }
};

/**
 * Gets the news item page size from global settings with fallback to default
 * @returns Promise with page size number
 */
export const getNewsItemPageSize = async (): Promise<number> => {
  try {
    const settings = await getGlobalSettings();
    const pageSize = settings.newsItemPageSize || 5; // Default to 5 if not set
    return pageSize;
  } catch (error) {
    console.error('Error getting news item page size, using default:', error);
    return 5; // Fallback to default
  }
};

/**
 * Gets the saveNewsItemContent setting from global settings with fallback to default
 * @returns Promise with boolean indicating whether to save news item content
 */
export const getSaveNewsItemContentSetting = async (): Promise<boolean> => {
  try {
    const settings = await getGlobalSettings();
    const saveContent = settings.saveNewsItemContent;
    
    if (typeof saveContent === 'boolean') {
      return saveContent;
    }
    
    // Default to false if not found in settings (conservative approach)
    return false;
  } catch (error) {
    console.error('Error getting save news item content setting, using default:', error);
    return false; // Fallback to default (conservative approach)
  }
};